import React, { useEffect, useState } from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Paper,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import OtherPostsHelpDialog from "../../../Components/Popups/OtherPostsHelpDialog";

const OtherPosts = () => {
  const [posts, setPosts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("created_at");
  const [searchName, setSearchName] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [openHelp, setOpenHelp] = useState(false);
  const [visible, setVisible] = useState(true);

  const fetchPosts = async (currentPage = page, currentRowsPerPage = rowsPerPage) => {
    try {
      const params = {
        page: currentPage + 1,
        limit: currentRowsPerPage,
        orderBy,
        order,
      };
      if (searchName) params.searchName = searchName;
      if (searchEmail) params.searchLink = searchEmail;
      if (filterStatus !== "") params.filterStatus = filterStatus;
      if (filterDate) params.filterDate = filterDate;

      const response = await axios.get(
        "https://kariyer.biyomed.net/api/admin/getAllOtherPosts",
        { withCredentials: true, params }
      );
      setPosts(response.data.job_listings || []);
      setTotal(response.data.total || 0);
    } catch (error) {
      console.error("İlanlar çekilirken bir hata oluştu:", error);
      setPosts([]);
      setTotal(0);
    }
  };

  useEffect(() => {
    fetchPosts(page, rowsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, order, orderBy]);

  const handleSearch = () => {
    setPage(0);
    fetchPosts(0, rowsPerPage);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };

  const handleLinkedInShare = async (post) => {
    try {
      // post içindeki alanları destructure ediyoruz
      const {
        id,
        position_name,
        city,
        job_link,
        company_name,
        position_category,
        job_type,
        job_status,
      } = post;

      // city array ise virgülle birleştiriyoruz
      const cityString = Array.isArray(city) ? city.join(", ") : city;

      // Axios POST isteği
      const response = await axios.post(
        "https://kariyer.biyomed.net/api/admin/linkedinshareOtherPost",
        {
          id,
          position_name,
          city: cityString,
          job_link,
          company_name,
          position_category,
          job_type,
          job_status,
        },
        { withCredentials: true },
      );

      console.log("LinkedIn paylaşımı başarılı:", response.data);
      alert("Paylaşım başarılı!");

      await fetchPosts(); // Paylaşım sonrası verileri güncellemek için ilanları tekrar çekiyoruz
    } catch (error) {
      console.error("LinkedIn paylaşımında hata:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => setVisible((v) => !v), 800); // 0.5 saniye yanıp sönme
    return () => clearInterval(interval);
  }, []);
  // Sıralama işlemi uygulanmış veriyi döndürme
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Silme işlemi
  const handleDelete = async (id, post) => {
    const confirmMessage =
      "Silmek istediğinize emin misiniz?\n\n" +
      "Sistem tarafından eklenen bir duyuruyu siliyorsanız, sistemin tekrar çekebileceğini unutmayınız. " +
      "Eğer sistemde kullanılmayacaksa ve sistem tarafından otomatik çekilen bir duyuruyu siliyorsanız, " +
      "lütfen Güncelle tarafında ilan durumunu 'Gereksiz' olarak işaretleyiniz.";

    if (!window.confirm(confirmMessage)) {
      return; // Kullanıcı iptal ettiyse işlemi durdur
    }

    try {
      // API'ye DELETE isteği gönder
      await axios.delete(
        `https://kariyer.biyomed.net/api/admin/deleteOtherPost/${id}`,
        { withCredentials: true },
      );
      await fetchPosts();

      alert("Silme işlemi başarılı.");
    } catch (error) {
      console.error("İlan silinirken bir hata oluştu:", error);
      alert("Silme işlemi sırasında bir hata oluştu.");
    }
  };

  const handleUpdate = async (postId) => {
    window.location.href = `admin/updateOtherPost/${postId}`;
  };

  return (
    <>
      <TextField
        label="Pozisyon İsimiyle Ara"
        variant="outlined"
        fullWidth
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        style={{ marginBottom: 20, maxWidth: 200, marginLeft: 20 }}
      />
      <TextField
        label="İş Linki ile Ara"
        variant="outlined"
        fullWidth
        value={searchEmail}
        onChange={(e) => setSearchEmail(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        style={{ marginBottom: 20, maxWidth: 200, marginLeft: 20 }}
      />
      <FormControl style={{ minWidth: 200, marginLeft: 20, marginBottom: 20 }}>
        <InputLabel>İlan Durumu</InputLabel>
        <Select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <MenuItem value="">Tümü</MenuItem>
          <MenuItem value={0}>Pasif</MenuItem>
          <MenuItem value={1}>Aktif</MenuItem>
          <MenuItem value={2}>Gereksiz</MenuItem>
        </Select>
      </FormControl>
      <TextField
        style={{ marginLeft: 20 }}
        label="Kayıt Tarihi"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={filterDate}
        onChange={(e) => setFilterDate(e.target.value)}
      />
      <Button
        variant="contained"
        style={{ marginLeft: 20, height: 40, marginTop: 7 }}
        onClick={handleSearch}
      >
        Ara
      </Button>
      {/* Yardım Butonu */}
      <Button
        variant="outlined"
        startIcon={<HelpOutlineIcon />}
        style={{ marginLeft: 20, height: 40, marginTop: 7 }}
        onClick={() => setOpenHelp(true)}
      >
        Yardım
      </Button>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sortDirection={orderBy === "created_at" ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === "created_at"}
                    direction={orderBy === "created_at" ? order : "asc"}
                    onClick={() => handleRequestSort("created_at")}
                  >
                    Oluşturulma Tarihi
                  </TableSortLabel>
                </TableCell>
                <TableCell>Pozisyon Adı</TableCell>
                <TableCell>Şehir (Adres)</TableCell>
                <TableCell>İş Linki</TableCell>
                <TableCell>Şirket Adı</TableCell>
                <TableCell>
                  <Tooltip title="LinkedIn paylaşma durumu">
                    <LinkedInIcon style={{ cursor: "pointer" }} />
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title="İlanın biyomedikal mühendisliğine uygunluğu (AI)">
                    <span
                      style={{
                        marginRight: "5px",
                        cursor: "default",
                        fontSize: "18px",
                      }}
                    >
                      🤖
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Tooltip title="Sistem Tarafından Eklendi">
                    <span
                      style={{
                        cursor: "default",
                        marginRight: "5px",
                        fontSize: "18px",
                      }}
                    >
                      ⚙️
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell>İlan Durumu</TableCell>
                <TableCell>İşlemler</TableCell>{" "}
                {/* Sil butonu için yeni bir sütun ekliyoruz */}
              </TableRow>
            </TableHead>
            <TableBody>
              {posts.map((post) => (
                  <TableRow hover key={post.id}>
                    <TableCell>
                      {new Date(post.created_at)
                        .toISOString()
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join(".")}
                    </TableCell>
                    <TableCell>{post.position_name}</TableCell>
                    <TableCell>{post.city}</TableCell>
                    <TableCell>
                      <a
                        href={
                          post.job_link.startsWith("http://") ||
                          post.job_link.startsWith("https://")
                            ? post.job_link
                            : "https://" + post.job_link
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        İş Linki
                      </a>
                    </TableCell>
                    <TableCell>{post.company_name}</TableCell>
                    <TableCell>
                      {post.linkedin_status === 1 ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          ✅
                        </span>
                      ) : post.linkedin_status === 0 ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          ❌
                          {post.suitable === 1 && (
                            <span
                              style={{
                                marginLeft: "5px",
                                color: "#1b397eff",
                                fontSize: 20,
                                opacity: visible ? 1 : 0,
                                transition: "opacity 0.3s",
                              }}
                            >
                              <LinkedInIcon style={{ marginBottom: -7 }} />
                            </span>
                          )}
                        </span>
                      ) : (
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          🚫 Bilinmiyor
                        </span>
                      )}
                    </TableCell>

                    <TableCell>
                      {post.suitable === 1 ? (
                        <>
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            ✅
                          </span>
                        </>
                      ) : post.suitable === 0 ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          ❌
                        </span>
                      ) : post.suitable === 2 ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          🤖💤
                        </span>
                      ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          🚫
                        </span>
                      )}
                    </TableCell>
                    <TableCell>
                      {post.website_id ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          ✅
                        </span>
                      ) : (
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          ❌ Manuel Eklendi
                        </span>
                      )}
                    </TableCell>
                    <TableCell>
                      {post.job_status === 1 ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          ✅ Aktif
                        </span>
                      ) : post.job_status === 0 ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          {" "}
                          ❌ Pasif
                        </span>
                      ) : (
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          🗑️ Gereksiz
                        </span>
                      )}
                    </TableCell>
                    <TableCell>
                      {/* Sil butonunu buraya ekliyoruz */}
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleUpdate(post.id)}
                        sx={{ fontSize: 10 }}
                      >
                        Güncelle
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => handleDelete(post.id)}
                        sx={{ marginLeft: 1, fontSize: 10 }}
                      >
                        Sİl
                      </Button>

                      {post.linkedin_status === 0 ||
                      post.linkedin_status === null ? (
                        <Button
                          variant="contained"
                          color="info"
                          size="small"
                          startIcon={<LinkedInIcon />}
                          sx={{ marginLeft: 1, fontSize: 10 }}
                          onClick={() => handleLinkedInShare(post)}
                        >
                          Paylaş
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="inherit"
                          size="small"
                          startIcon={<LinkedInIcon />}
                          sx={{ marginLeft: 1, fontSize: 10 }}
                          onClick={() => handleLinkedInShare(post)}
                        >
                          Tekrar Paylaş
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Yardım Dialogu */}
      <OtherPostsHelpDialog
        open={openHelp}
        onClose={() => setOpenHelp(false)}
      />
    </>
  );
};

export default OtherPosts;
